export default __webpack_public_path__ + "static/media/genhaven-color1.dfb7e4cc.webp";